
/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator';
import { loteStore, graficaStore, productStore, companyStore } from '@/store';
import { ILoteCreate } from '@/interfaces/lote';
import { ILoteItem } from '@/interfaces/lote_item';
import { required } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { ICompany } from '@/interfaces/company';
import DialogUploadFileComponent from '@/components/DialogUploadFileComponent.vue';
extend('required', {
  ...required,
  message: 'O campo {_field_} deve ser preenchido!',
});
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    DialogUploadFileComponent,
  },
})
export default class CreateLote extends Vue {
  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  public headers = [
    {
      text: 'Produto',
      sortable: true,
      value: 'product.item_name',
      align: 'left',
    },
    {
      text: 'Quantidade',
      sortable: true,
      value: 'quantity',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
    },
  ];

  public lote = {
    grafica: {},
    unidade: {},
  };

  public isLoading = false;

  public company = {};

  public productSelected = {};

  public quantity = 1;

  public search = '';

  public loteItems: ILoteItem[] = [];
  public unidades: ICompany[] = [];

  get validInvoice() {
    return this.loteItems.length < 1;
  }
  // get quantityItems () {
  // ['quantity']
  // return this.loteItems.reduce((a, b) => parseInt(a.quantity) + parseInt(b.quantity || 0), 0);
  // }
  get products() {
    return productStore.products;
  }

  get isDisabled() {
    return !(this.loteItems.length > 0 && this.lote.grafica && this.lote.unidade);
  }

  public addLoteItem() {
    this.loteItems.push({
      // @ts-ignore
      product: this.productSelected,
      quantity: this.quantity,
    });
  }

  public addQuantity(item, value) {
    item.quantity = item.quantity + value;
  }

  get graficas() {
    return graficaStore.graficas;
  }

  public async updateProducts() {
    await productStore.getProducts({
      company_id: this.lote.unidade['id'],
      is_lote: true,
    });
  }

  public deleteLoteItem(item) {
    // @ts-ignore
    this.loteItems = this.loteItems.filter(function (el) {
      // @ts-ignore
      return el.product.C015_CodigoProduto != item.product.C015_CodigoProduto;
    });
  }

  public cancel() {
    this.$router.back();
  }

  public async clearFields() {
    this.lote.unidade = {};
    this.lote.grafica = {};
    this.productSelected = {};
    this.loteItems = [];
    this.quantity = 1;
  }

  public async doSubmit() {
    this.isLoading = true;
    const lote: ILoteCreate = {
      grafica: this.lote.grafica,
      items: this.loteItems,
      unidade: this.lote.unidade,
    };

    const loteId = await loteStore.createLote(lote);
    const el: any = this.$refs['comprovanteFileUpload'];

    if (el && el.inputFiles.length > 0 && loteId) {
      await el.uploadFiles(loteId);
    }

    this.$router.push({ name: 'main-lote-all' });
    this.isLoading = false;
  }

  public async mounted() {
    await graficaStore.getGraficas();
    this.unidades.push(await companyStore.getCompany({ id: 1 }));
    this.unidades.push(await companyStore.getCompany({ id: 1069 }));

    this.clearFields();
  }
}
